import { createSelector } from 'reselect'

const drawItSelector = state => state.drawIt

const drawItUploadReferenceMediaSelector = createSelector(
	[ drawItSelector ],
	drawItState => ({
		entityUID: drawItState.entityUID,
		presentationId: drawItState.presentationId,
	})
)

export default drawItUploadReferenceMediaSelector
